import { Directive, Input, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { PropertyFilter, PropertyService } from '../property.service'
import { coerceBooleanProperty } from '@angular/cdk/coercion'
import { Property, PropertyKind } from '../property'

@Directive({
  selector: '[appPropertySelect]',
})
export class PropertySelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const propertyService = inject(PropertyService)
    this.select.displayPropertyResolver = this.displayResolverFn
    this.select.placeholder = 'properties.property'
    this.select.dataSource = propertyService
    this.select.sorts = [new Sort('id', 'asc')]
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set kinds(kinds: PropertyKind[]) {
    if (kinds) {
      this.select.filters = [PropertyFilter.kinds(...kinds)]
    }
  }

  @Input()
  public set productKind(value: any) {
    if (coerceBooleanProperty(value)) {
      this.select.filters = [PropertyFilter.kinds(PropertyKind.PRODUCT, PropertyKind.ITEM)]
      this.select.placeholder = 'products.properties.property'
    }
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private displayResolverFn(property: Property): string {
    if (!property) {
      return null
    } else {
      return property.description ? property.description : property.id
    }
  }
}
